import { render, staticRenderFns } from "./ChildItems.vue?vue&type=template&id=f063030a&scoped=true&"
import script from "./ChildItems.vue?vue&type=script&lang=js&"
export * from "./ChildItems.vue?vue&type=script&lang=js&"
import style0 from "./ChildItems.vue?vue&type=style&index=0&id=f063030a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f063030a",
  null
  
)

export default component.exports